import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserAvatarComponent } from '@hglobal/common';

import { AvatarComponent } from './avatar.component';

@NgModule({
  declarations: [AvatarComponent],
  imports: [
    CommonModule,
    UserAvatarComponent,
  ],
  exports: [AvatarComponent],
})
export class AvatarModule {}
